import React, { useState, useEffect }from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {ContainerMain} from '../common/commonStyles'
import {BackArrowFeed} from '../../utils/icons'
import {ReportHeading, WbaReportCard, CategoryCard, QueAnsWrapper} from './styles'
import { ImageUrl } from '../../utils/constants';
import { fetchApi } from "../../utils/methods";
import { toast } from "react-toastify";
import { getWBAQuestionAnswersForUser } from "../../redux/constants/apiConstants";
import SkeletonLoder from '../common/skeletonLoder';

const HealthReport = ({history, user}) => {
  const [ansAndQuestionData, setAnsAndQuestionData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('medical');
  const [showLoader, setshowLoader] = useState(false);

  useEffect(() => {
    getWellneeDataToYear(selectedCategory);
  }, [])

  const dataByCategory = (type) => {
    getWellneeDataToYear(type);
    setSelectedCategory(type)
  }

  const getTotalWellbeingPercentage = (value) => {
    if (value) {
      return `${Math.round((value / 240) * 100)}%`;
    }
    else {
      return '0%';
    }
  }

  const getWellneeDataToYear = async (type) => {
    try {
      const res = await fetchApi(`/${getWBAQuestionAnswersForUser}/${type}/${user?.uid}`, "GET");
      if (res.data.message) {
        toast.error(res.data.message);
      } else {
        setAnsAndQuestionData(res?.data)
        setshowLoader(true)
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getWbaReport = () => {
    const wellbeingAssesmentData=history?.location?.state?.wellbeingAssesmentData
    const totalCount=wellbeingAssesmentData[0]?.fill1+wellbeingAssesmentData[1]?.fill1+wellbeingAssesmentData[2]?.fill1+wellbeingAssesmentData[3]?.fill1+wellbeingAssesmentData[4]?.fill1+wellbeingAssesmentData[5]?.fill1;
    const totalPercentage=getTotalWellbeingPercentage(totalCount)
    return (
      <WbaReportCard>
        <div className='heading'>
          <div className='start'>
            <div className='title'>My WBA Reports</div>
            <div className='line'/>
            <div className='total'>Total Score: {totalCount}/240 | {totalPercentage}</div>
          </div>
        </div>
        <div className='border'/>
        <div className="category-wrapper">
          {wellbeingAssesmentData?.map((data,index)=>
            <CategoryCard key={index} color={data?.color} active={data?.type==selectedCategory} onClick={()=>dataByCategory(data?.type)}>
              <div className="icon">
                <img src={ImageUrl+ data?.imgUrl} alt="icon"/>
              </div>
              <div className="wrap">
                <div className="category">{data.title}</div>
                <div className="score">{data.label}/40</div>
              </div>
            </CategoryCard>)
          }
        </div>
      </WbaReportCard>
    )
  };

  return (
    <>
      <ContainerMain>
        <div className="content-wrap">
          <ReportHeading>
            <div className="icon" onClick={() => history.push({ pathname: `/profile`, state: { key: history?.location?.state?.key } })}>
              {BackArrowFeed()}
            </div>
            <div className="title">Assessment</div>
          </ReportHeading>
          {getWbaReport()}
          {!showLoader?<SkeletonLoder width="100%" height="500px"/>:ansAndQuestionData?.length===0?null:
            <QueAnsWrapper showBorder={true}>
              <div className="wrapper">
                {ansAndQuestionData?.map((data,index)=>
                  <>
                    <div className="content">
                      <div className="question">Q{index+1}.{" "}{data?.question}</div>
                      {data?.emoji}
                      <div className="answer">{data?.answers}</div>
                    </div>
                    {index+1!==ansAndQuestionData?.length&&<div className="border"/>}
                  </>)}
              </div>
            </QueAnsWrapper>}
        </div>
      </ContainerMain>
    </>
  );
};

HealthReport.propTypes = {
  selectedYearInfo: PropTypes.number,
  history: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.profileData.user
})

export default connect(mapStateToProps, null)(HealthReport);